import { useRouter } from 'next/router';
import stringifyUrl from '@/common/services/helpers/stringifyUrl';
import useTripId from '@/common/services/hooks/useTripId';
import useBid from '@/common/services/hooks/useBid';
import { omitCommonPathParams } from '@/common/services/utils/omitCommonPathParams';
import usePathLanguage from '@/common/services/hooks/usePathLanguage';

type TravelCompanionPaths = {
  details: string;
  itineraryDetails: (params: { bid: number }) => string;
};

const useTravelCompanionPaths = (): TravelCompanionPaths => {
  const { query } = useRouter();
  const tripId = useTripId() as number;
  const bid = useBid() as number;
  const language = usePathLanguage();

  const otherQueries = omitCommonPathParams(query);

  if (tripId) {
    return {
      details: stringifyUrl({
        url: `/${language}/trip-companion/${tripId}`,
        query: otherQueries,
      }),
      itineraryDetails: ({ bid }) =>
        stringifyUrl({
          url: `/${language}/trips/${bid}/itinerary-details`,
          query: otherQueries,
        }),
    };
  }

  return {
    details: stringifyUrl({
      url: `/${language}/trips/${bid}/live-boarding-pass`,
      query: otherQueries,
    }),
    itineraryDetails: () =>
      stringifyUrl({
        url: `/${language}/trips/${bid}/itinerary-details`,
        query: otherQueries,
      }),
  };
};

export default useTravelCompanionPaths;
